module.exports = __webpack_public_path__ + "img/labmem_text_language_sc.959ef6cc.png";